export default __webpack_public_path__ + "static/media/pokedex.504c4fbd.png";